module.exports = __webpack_public_path__ + "assets/sd-user-icon.6500d3cb.svg";